import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import EditPallet from "./modal-edit-pallet";
import AddPallet from "./modal-add-pallet";
import "../../../../assets/css/style-table.css";
import ImportPallet from "./modal-import-pallet";

const { confirm } = Modal;

const Pallet = () => {
  const [dataPallet, setDataPallet] = useState([]);
  const [dataPalletFilter, setDataPalletFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [showImport, setShowImport] = useState(false);
  const onShowImport = (val) => {
    setShowImport(val);
  };

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getPallet = async () => {
    state.LOADING = true;

    await API.Get("pallet")
      .then((result) => {
        setDataPallet(result?.data);
        setDataPalletFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Pallet Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getPallet();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`pallet/${data.id}`)
          .then(() => {
            message.success("Pallet has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Pallet");
            console.error(err);
          })
          .finally(() => {
            getPallet();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "RFID Number",
      dataIndex: "rfid",
      key: "rfid",
      sorter: (a, b) => {
        if (a.rfid?.number === null || a.rfid?.number === "-") return 1;
        if (b.rfid?.number === null || b.rfid?.number === "-") return -1;
        return a.rfid?.number.localeCompare(b.rfid?.number);
      },
      render: (rfid) => (rfid ? rfid?.number : "-"),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      render: (name) => (name ? name : "-"),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => {
        if (a.type === null || a.type === "-") return 1;
        if (b.type === null || b.type === "-") return -1;
        return a.type.localeCompare(b.type);
      },
      render: (type) => (type ? type : "-"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => {
        if (a.created_at === null || a.created_at === "-") return 1;
        if (b.created_at === null || b.created_at === "-") return -1;
        return a.created_at.localeCompare(b.created_at);
      },
      render: (created_at) =>
        created_at ? dayjs(created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      sorter: (a, b) => {
        if (a.updated_at === null || a.updated_at === "-") return 1;
        if (b.updated_at === null || b.updated_at === "-") return -1;
        return a.updated_at.localeCompare(b.updated_at);
      },
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataPallet.filter((pallet) =>
      pallet.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataPalletFilter(data);
  };

  const onClear = async (val) => {
    getPallet();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu
        onShowAdd={onShowAdd}
        onSearch={onSearch}
        onClear={onClear}
        onShowImport={onShowImport}
      />

      {/* Pallet Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataPalletFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Pallet */}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddPallet
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetPallet={getPallet}
        />
      </div>

      {/* Modal Edit Pallet */}
      <EditPallet
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetPallet={getPallet}
        selectedData={selectedData}
      />

      <ImportPallet showImport={showImport} onShowImport={onShowImport} />
    </>
  );
};

export default Pallet;
